import { render } from "./WirepasLocationDetailView.vue?vue&type=template&id=2b07b0db&scoped=true&ts=true"
import script from "./WirepasLocationDetailView.vue?vue&type=script&lang=ts"
export * from "./WirepasLocationDetailView.vue?vue&type=script&lang=ts"

import "./WirepasLocationDetailView.vue?vue&type=style&index=0&id=2b07b0db&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b07b0db"]])

export default __exports__